<template>
  <a-modal
    :title="isAdd ? '添加字典类型' : '编辑字典类型'"
    :visible="visible"
    :confirmLoading="submitting"
    okText="提交"
    cancelText="取消"
    @ok="handleSubmit"
    @cancel="$emit('update:visible', false)"
  >
    <a-form :form="form" @keydown.enter.native="handleSubmit">
      <a-form-item label="字典类型名称" v-bind="formItemLayout">
        <a-input
          placeholder="字典类型名称"
          v-decorator="['name', {
            validateFirst: true,
            normalize: trimNormalizer,
            rules: [
              {required: true, message: '请输入字典类型名称'},
              {max: 32, message: '您可以尝试输入简短一些'}
            ]
          }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="字典类型code" v-bind="formItemLayout">
        <a-input
          placeholder="字典类型code,一旦添加不可修改"
          v-decorator="['icon', {
            validateFirst: true,
            normalize: trimNormalizer,
            rules: [
              {required: true, message: '请输入字典类型code'},
              {max: 32, message: '您可以尝试输入简短一些'}
            ]
          }]"
          :disabled="isEdit"
        ></a-input>
      </a-form-item>
      <a-form-item label="字典类型描述" v-bind="formItemLayout">
        <a-input placeholder="字典类型描述" v-decorator="['url', {
          rules: [{max: 255, message: '您可以尝试输入简短一些'}]
        }]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { trimNormalizer } from '@/utils/tools'
import { dict } from '@/api'

export default {
  name: 'DialogSysDictType',
  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    }
  },

  props: {
    visible: Boolean,
    sysDictType: [String, Object],
    isAdd: Boolean
  },

  computed: {
    isEdit () {
      return Boolean(this.sysDictType && this.sysDictType.id !== '0')
    }
  },

  data () {
    let form = this.$form.createForm(this)
    return {
      trimNormalizer,
      form,
      submitting: false
    }
  },

  mounted () {
    if (this.sysDictType && !this.isAdd) {
      this.form.setFieldsValue({
        name: this.sysDictType.name,
        icon: this.sysDictType.icon,
        url: this.sysDictType.url
      })
    }
  },

  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) return
        if (this.isAdd) {
          this.insertSysDictType(values)
        } else {
          this.updateSysDictType(values)
        }
      })
    },
    async insertSysDictType ({ icon, name, url }) {
      try {
        this.submitting = true
        let { code, msg } = await dict.addSysDictType({
          dictTypeCode: icon,
          dictTypeName: name,
          dictTypeDesc: url
        })
        if (code !== 0) throw new Error(msg || '添加失败')
        this.$message.success('添加成功')
        this.$emit('update:visible', false)
        this.$emit('submitted')
      } catch (e) {
        console.error(e.message)
      } finally {
        this.submitting = false
      }
    },
    async updateSysDictType (values) {
      try {
        this.submitting = true
        let { code, msg } = await dict.updateSysDictType({
          dictTypeCode: values.icon,
          dictTypeName: values.name,
          dictTypeDesc: values.url,
          dictTypeId: this.sysDictType.id
        })
        if (code !== 0) throw new Error(msg || '更新失败')
        this.$message.success('更新成功')
        this.$emit('update:sysDictType', {
          ...this.sysDictType,
          ...values
        })
        this.$emit('update:visible', false)
        this.$emit('submitted')
      } catch (e) {
        console.error(e.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
